import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';

@Component({
  selector: 'app-conditions-generales',
  standalone: true,
  imports: [],
  templateUrl: './conditions-generales.component.html',
  styleUrls: ['../../../assets/styles/pages-legales.css'],
})
export class ConditionsGeneralesComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateMeta(
      'Conditions générales d’utilisation — Qaryos',
      'Consultez les conditions générales d’utilisation du service Qaryos : responsabilités, confidentialité et engagements des utilisateurs.'
    );
  }
}
